import { wheelCores } from '../EmotionWheel/data'

// Maps every emotion label on the wheel to its core family + a colour, so a
// free-text response tagged with any feeling can be grouped and coloured in
// the results view.
export const emotionIndex = (() => {
  const idx = {}
  wheelCores.forEach((core) => {
    idx[core.name] = { core: core.name, color: core.colors.core }
    core.branches.forEach((branch) => {
      idx[branch.name] = { core: core.name, color: core.colors.branch }
      branch.outer.forEach((outer) => {
        idx[outer] = { core: core.name, color: core.colors.outer }
      })
    })
  })
  return idx
})()

export const coreOrder = wheelCores.map((c) => ({
  name: c.name,
  color: c.colors.core,
}))

export const colorFor = (emotion) => emotionIndex[emotion]?.color || '#9b6fc4'
export const coreFor = (emotion) => emotionIndex[emotion]?.core || 'Surprise'

// Seed "what others said" responses - prototype stand-in for whatever the
// backend will return. Anonymous, first-person, deliberately varied.
export const seededResponses = [
  {
    emotion: 'Curious',
    note: "I keep finding new things it can do - and I can't stop poking at it.",
  },
  {
    emotion: 'Overwhelmed',
    note: 'It moves faster than I can keep up with, and that never quite stops.',
  },
  {
    emotion: 'Hopeful',
    note: 'Maybe it finally frees us up for the work that actually matters.',
  },
  {
    emotion: 'Provoked',
    note: 'Shocked how good it already is at things I trained years to do.',
  },
  {
    emotion: 'Worried',
    note: 'Mostly about what this does to how my kids will learn and think.',
  },
  {
    emotion: 'Excited',
    note: 'First tech in a long while that feels genuinely new to me.',
  },
  {
    emotion: 'Vulnerable',
    note: 'I use AI because I feel I have to now, and that quietly scares me.',
  },
  {
    emotion: 'Skeptical',
    note: "Half of it is hype. The other half I'm honestly not sure about yet.",
  },
  {
    emotion: 'Inspired',
    note: "It nudges me toward ideas I don't think I'd have reached alone.",
  },
  {
    emotion: 'Anxious',
    note: 'Quietly worried about my job, if I let myself think about it.',
  },
  {
    emotion: 'Guilty',
    note: 'Feels like cheating some days, even when it clearly helps.',
  },
  {
    emotion: 'Amazed',
    note: 'Every so often it does something that genuinely stops me short.',
  },
]
